import { createContext, useContext, useState, ReactNode } from "react";
import { types } from "./definitions";

// Define the context type
type PromptContextType = {
  userPrompt?: types.Prompt;
  handleUserPromptUpdate: (prompt: types.Prompt) => void;
  userPromptList?: types.Prompt[];
  handleUserPromptListUpdate: (prompts: types.Prompt[]) => void;
  userHasPrompts?: boolean;
  handleUserHasPromptsUpdate: (hasPrompts: boolean) => void;
};

const PromptContext = createContext<PromptContextType>({
  userPrompt: undefined,
  handleUserPromptUpdate: () => {
    // No-op implementation to satisfy TypeScript
    return;
  },
  userPromptList: undefined,
  handleUserPromptListUpdate: () => {
    // No-op implementation to satisfy TypeScript
    return;
  },
  userHasPrompts: undefined,
  handleUserHasPromptsUpdate: () => {
    // No-op implementation to satisfy TypeScript
    return;
  },
});

export const PromptProvider = ({ children }: { children: ReactNode }) => {
  const [userPrompt, setUserPrompt] = useState<types.Prompt | undefined>();
  const [userPromptList, setUserPromptList] = useState<
    types.Prompt[] | undefined
  >();
  const [userHasPrompts, setUserHasPrompts] = useState<boolean | undefined>();

  const handleUserPromptUpdate = (prompt: types.Prompt) => {
    setUserPrompt(prompt);
  };

  const handleUserPromptListUpdate = (prompts: types.Prompt[]) => {
    setUserPromptList(prompts);
  };

  const handleUserHasPromptsUpdate = (hasPrompts: boolean) => {
    setUserHasPrompts(hasPrompts);
  };

  return (
    <PromptContext.Provider
      value={{
        userPrompt,
        handleUserPromptUpdate,
        userPromptList,
        handleUserPromptListUpdate,
        userHasPrompts,
        handleUserHasPromptsUpdate,
      }}
    >
      {children}
    </PromptContext.Provider>
  );
};

export const usePromptContext = () => {
  const context = useContext(PromptContext);
  if (context === undefined) {
    throw new Error("usePromptContext must be used within a PromptProvider");
  }
  return context;
};
